import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React from 'react';
import { NumberCell, DateCell } from '../../../utils/Cells';
import * as util from '../../../utils/EnumMapping';

function getItems(items) {
    // console.log(items);
    const result = new Map()
    let sortedResult = new Map()
    /* eslint-disable array-callback-return */
    items && items.map(item => {
        if (result.has(item.partnerId)) {
            const existingElement = result.get(item.partnerId);
            existingElement.remainingAmount = existingElement.remainingAmount + item.remainingAmount;
            existingElement.payables.push(item);
        } else {
            const newElement = {
                partnerId: item.partnerId,
                partnerName: item.partnerName,
                type: item.payableType,
                typeLabel: util.getLabel(util.owingTypes, item.payableType),
                remainingAmount: item.remainingAmount,
                bankAccountNumbers: item.bankAccountNumbers,
                payables: [item]
            }
            result.set(item.partnerId, newElement);
        }
    })
    /* eslint-enable array-callback-return */
    if (items) {
        sortedResult = new Map([...result.entries()].sort((a, b) => b[1].remainingAmount - a[1].remainingAmount))
    }
    // console.log(sortedResult);
    return [...sortedResult.values()];
}

export default function CustomList(props) {
    React.useEffect(() => {
        // console.log(props);
    }, [props]);

    const MultiRow = (props) => {
        const value = props.value;
        // console.log(value);
        return (
            <>
                <TableRow key={value.privateId}>
                    <TableCell className="bold" padding="checkbox"></TableCell>
                    <TableCell className="bold" ><div>{value.partnerName}</div><div>{value.typeLabel}</div></TableCell>
                    <TableCell></TableCell>
                    <TableCell className="bold"></TableCell>
                    <TableCell className="bold" align="right"><NumberCell value={value.remainingAmount} /></TableCell>
                    {props.full && <TableCell className="bold">{value.bankAccountNumbers}</TableCell>}
                </TableRow>
                {value.payables && value.payables.map((row) => {
                    const isItemSelected = props.checked ? props.checked.indexOf(row) !== -1 : false;
                    const labelId = `transfer-list-item-${row.privateId}-label`;
                    return (
                        <TableRow
                            key={row.privateId}
                            hover
                            button
                            onClick={props.handleToggle(row)}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            selected={isItemSelected}
                        >
                            <TableCell padding="checkbox">
                                <Checkbox
                                    checked={isItemSelected}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ 'aria-labelledby': labelId }}
                                />
                            </TableCell>
                            <TableCell></TableCell>
                            <TableCell>{row.comment}</TableCell>
                            <TableCell width='83px'><DateCell value={row.paymentDeadline} /></TableCell>
                            <TableCell width='40px' align="right"><NumberCell value={row.remainingAmount} /></TableCell>
                            {props.full && <TableCell></TableCell>}
                        </TableRow>
                    )
                })}
            </>
        )
    };

    const SingleRow = (props) => {
        const value = props.value;
        // console.log(value);
        const row = value.payables[0];
        const isItemSelected = props.checked ? props.checked.indexOf(row) !== -1 : false;
        const labelId = `transfer-list-item-${row.privateId}-label`;
        return (
            <TableRow
                key={row.privateId}
                hover
                button
                onClick={props.handleToggle(row)}
                role="checkbox"
                aria-checked={isItemSelected}
                tabIndex={-1}
                selected={isItemSelected}
            >
                <TableCell className="bold" padding="checkbox">
                    <Checkbox
                        checked={isItemSelected}
                        tabIndex={-1}
                        disableRipple
                        inputProps={{ 'aria-labelledby': labelId }}
                    /></TableCell>
                <TableCell className="bold" ><div>{value.partnerName}</div><div>{value.typeLabel}</div></TableCell>
                <TableCell>{row.comment}</TableCell>
                <TableCell className="bold"><DateCell value={row.paymentDeadline} /></TableCell>
                <TableCell className="bold" align="right"><NumberCell value={value.remainingAmount} /></TableCell>
                {props.full && <TableCell className="bold">{value.bankAccountNumbers}</TableCell>}
            </TableRow>
        )
    };

    return (
        <div id="custom-list">
            <h3 className="table-title">{props.title}</h3>
            <TableContainer component={Paper} className={props.className}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell padding="checkbox"></TableCell>
                            <TableCell className="bold">Név/Megnevezés</TableCell>
                            <TableCell className="bold">Sorszám/Megjegyzés</TableCell>
                            <TableCell width='83px' className="bold">Határidő</TableCell>
                            <TableCell width='40px' className="bold" align="right">Összeg</TableCell>
                            {props.full && <TableCell className="bold" >Bankszámlaszám</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.items && getItems(props.items).map((value, key, map) => {
                            // console.log(value);
                            if (value.payables && value.payables.length > 1) {
                                return <MultiRow {...props} value={value} />
                            } else {
                                return <SingleRow {...props} value={value} />
                            }
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}
